import _ from 'lodash';
import { Types } from '../actions/surveyActions';

const defaultSurveyState = {
  reportingPeriods: [],
  campaigns: [],
  /** From GET /my/survey/campaigns `invitationTotals` (org-wide aggregates). */
  invitationTotals: null,
  currentCampaign: null,
  campaignResults: null,
  campaignReport: null,
  campaignResponses: [],
  tokenMeta: null,
  tokenQuestions: [],
  draftResponseData: {},
  loading: {},
  error: null,
};

const surveyReducers = (state, action) => {
  const newState = _.cloneDeep(state);

  switch (action.type) {
    case Types.SURVEY_SET_LOADING: {
      const { section, value } = action.payload || {};
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        loading: {
          ...(newState.survey?.loading || {}),
          [section]: value,
        },
      };
      return newState;
    }

    case Types.SURVEY_SET_ERROR:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        error: action.payload || null,
      };
      return newState;

    case Types.SURVEY_SET_CAMPAIGNS: {
      const raw = action.payload;
      const campaigns = Array.isArray(raw) ? raw : raw?.campaigns ?? [];
      const invitationTotals = Array.isArray(raw) ? null : raw?.invitationTotals ?? null;
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        campaigns: Array.isArray(campaigns) ? campaigns : [],
        invitationTotals: invitationTotals && typeof invitationTotals === 'object' ? invitationTotals : null,
      };
      return newState;
    }

    case Types.SURVEY_SET_REPORTING_PERIODS:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        reportingPeriods: Array.isArray(action.payload) ? action.payload : [],
      };
      return newState;

    case Types.SURVEY_SET_CURRENT_CAMPAIGN:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        currentCampaign: action.payload || null,
      };
      return newState;

    case Types.SURVEY_SET_CAMPAIGN_RESULTS:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        campaignResults: action.payload || null,
      };
      return newState;

    case Types.SURVEY_SET_CAMPAIGN_REPORT:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        campaignReport: action.payload || null,
      };
      return newState;

    case Types.SURVEY_SET_CAMPAIGN_RESPONSES:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        campaignResponses: Array.isArray(action.payload) ? action.payload : [],
      };
      return newState;

    case Types.SURVEY_SET_TOKEN_META:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        tokenMeta: action.payload || null,
      };
      return newState;

    case Types.SURVEY_SET_TOKEN_QUESTIONS:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        tokenQuestions: Array.isArray(action.payload) ? action.payload : [],
      };
      return newState;

    case Types.SURVEY_SET_DRAFT_RESPONSE_DATA:
      newState.survey = {
        ...(newState.survey || defaultSurveyState),
        draftResponseData: action.payload && typeof action.payload === 'object' ? action.payload : {},
      };
      return newState;

    default:
      return state;
  }
};

export default surveyReducers;
